<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">Cadastrar Terceiro</p>
    </div>
    <div>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md items-center"
      >
        <div class="col-md-2 col-sm-12 col-xs-12">
          <div>Unidade</div>
          <ListaUnidadesSelect class="input-new-design" />
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12">
          <div>Selecione o Parceiro</div>
          <q-select
            class="input-new-design"
            dense
            outlined
            v-model="filtros.parceiro"
            :options="listaParceiros"
            :option-label="
              (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
            "
          >
          </q-select>
        </div>
        <div>
          <p></p>
          <q-btn
            class="q-mt-xs"
            label="Cadastrar"
            no-caps
            icon="done"
            style="background-color: #21324a; border-radius: 8px; color: white"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span class="texto-titulo-modal">
              {{
                editarTerceiro
                  ? `Editar: ${nomeTerceiroEditar}`
                  : "Cadastrar Funcionário/Terceiro"
              }}
            </span>
          </div>
        </div>
        <div v-if="!editarTerceiro" style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Parceiro</div>
                <q-select
                  dense
                  outlined
                  class="input-new-design"
                  v-model="terceiro.parceiro"
                  :options="listaParceiros"
                  :option-label="
                    (opt) =>
                      Object(opt) === opt && 'nome' in opt ? opt.nome : ''
                  "
                >
                </q-select>
              </div>
              <div>
                <div class="texto-titulo-input">Nome</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="terceiro.nome"
                  dense
                  autocomplete="off"
                  outlined
                  maxlength="100"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Área</div>
                <q-select
                  class="input-new-design"
                  dense
                  outlined
                  v-model="terceiro.area"
                  :options="listaArea"
                  :option-label="
                    (opt) =>
                      Object(opt) === opt && 'nome' in opt ? opt.nome : ''
                  "
                >
                </q-select>
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Matricula</div>
                <q-input
                  autocomplete="off"
                  class="input-modal input-new-design"
                  v-model="terceiro.matricula"
                  dense
                  outlined
                />
              </div>
            </div>
            <div class="q-my-lg q-px-md">
              <q-btn
                label="Criar"
                style="
                  background-color: #21324a;
                  border-radius: 8px;
                  color: white;
                "
                no-caps
                icon="done"
                @click="criar()"
              />
            </div>
          </div>
        </div>
        <div v-else style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Parceiro</div>
                <q-select
                  dense
                  class="input-new-design"
                  outlined
                  v-model="dadoEditar.parceiroId"
                  :options="listaParceiros"
                  map-options
                  option-label="nome"
                  option-value="parceiroId"
                >
                </q-select>
              </div>
              <div>
                <div class="texto-titulo-input">Nome</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.nome"
                  autocomplete="off"
                  dense
                  outlined
                  maxlength="100"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Área</div>
                <q-select
                  dense
                  class="input-new-design"
                  outlined
                  map-options
                  v-model="dadoEditar.areaId"
                  :options="listaArea"
                  option-label="nome"
                  option-value="areaId"
                >
                </q-select>
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Matricula</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.matricula"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
            </div>
            <div class="q-my-lg q-px-md">
              <q-btn
                label="Editar"
                color="positive"
                no-caps
                icon="done"
                @click="editar()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </Transition>
    <div class="q-mt-xl">
      <div class="q-mt-lg">
        <q-table
          id="customers"
          table-header-class="bg-accent text-weight-bold"
          :rows="listaTerceiros"
          :columns="columns"
          class="tabela-tamanho-fixo"
          dense
          :rows-per-page-options="[0]"
          :loading="loading"
          color="primary"
          flat
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Empresas / Tarceiros Cadastrados</span
            >
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="id" :props="props">
                {{ props.row.terceiroId }}
              </q-td>
              <q-td class="text-left" key="nome" :props="props">
                {{ props.row.nome }}
              </q-td>
              <q-td class="text-left" key="matricula" :props="props">
                {{ props.row.matricula }}
              </q-td>
              <q-td class="text-left" key="matricula" :props="props">
                {{ props.row.areaId }}
              </q-td>
              <q-td class="text-left" key="ativo" :props="props">
                <div
                  v-if="props.row.ativo == true"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ "Sim" }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ "Não" }}
                  </div>
                </div>
              </q-td>
              <q-td class="center" key="editar" :props="props">
                <q-btn
                  icon="sym_o_edit"
                  flat
                  color="primary"
                  dense
                  no-caps
                  @click="
                    (rightDrawerOpen = true),
                      (editarTerceiro = true),
                      (dadoEditar = { ...props.row }),
                      (nomeTerceiroEditar = props.row.nome)
                  "
                />
              </q-td>
              <q-td class="center" key="nome" :props="props">
                <q-btn
                  icon="sym_o_delete"
                  flat
                  color="red"
                  dense
                  no-caps
                  @click="
                    (parceiroId = props.row.parceiroId),
                      (terceiroId = props.row.terceiroId),
                      (confirmacao = !confirmacao)
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir a Empresa / Terceiro?"
      :exibir="confirmacao"
      @resultado="removerTerceiro"
    />
  </q-page>
</template>

<script>
import { ref, onMounted, watch, reactive } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
export default {
  name: "Cadastrarterceiro",
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  setup() {
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const terceiro = ref({
      terceiroId: "",
      parceiro: "",
      nome: "",
      matricula: "",
      area: "",
      email: "",
      celular: "",
    });
    const confirmacao = ref(false);
    const area = ref({
      areaId: "",
      unidadeId: "",
      nome: "",
    });

    const parceiro = ref({
      parceiroId: "",
      cnpj: "",
      nome: "",
    });

    const filtros = reactive({
      area: "",
      parceiro: "",
    });
    const parceiroId = ref("");
    const terceiroId = ref("");
    const listaTerceiros = ref([]);
    const listaArea = ref([]);
    const listaParceiros = ref([]);

    const loading = ref(false);
    const $q = useQuasar();

    const myForm = ref(null);
    const dadoEditar = ref({});
    const store = useStore();
    let editarTerceiro = ref(false);
    let rightDrawerOpen = ref(false);
    const nomeTerceiroEditar = ref("");
    const columns = [
      {
        name: "id",
        label: "ID",
        field: "nome",
        align: "left",
        sortable: false,
      },
      {
        name: "nome",
        label: "Nome",
        field: "nome",
        align: "left",
        sortable: false,
      },
      {
        name: "matricula",
        label: "Matrícula",
        field: "matricula",
        align: "left",
        sortable: false,
      },
      {
        name: "areaId",
        label: "Área ID",
        field: "matricula",
        align: "left",
        sortable: false,
      },
      {
        name: "ativo",
        label: "Ativo",
        field: "ativo",
        align: "left",
        sortable: false,
        format: (val) => {
          return val == true ? "sim" : "não";
        },
      },
      {
        name: "editar",
        label: "Editar",
        align: "left",
      },
      {
        name: "remover",
        label: "Remover",
        align: "left",
      },
    ];

    let listarTerceiros = async () => {
      if (
        filtros.parceiro.parceiroId === "" ||
        filtros.parceiro.parceiroId == undefined
      ) {
        return;
      }
      loading.value = true;
      try {
        let resposta = await store.dispatch("ter/listarTerceiros", {
          parceiroId: filtros.parceiro.parceiroId,
          unidadeId: emitir.value.unidade.id,
        });

        listaTerceiros.value = resposta.listaterceiros;
        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    let listarArea = async () => {
      await emitir.value.unidade.id;
      try {
        let resposta = await store.dispatch("area/listar", {
          unidadeId: emitir.value.unidade.id,
        });
        listaArea.value = resposta.listaArea;
        // terceiro.value.areaId = listaArea.value;
      } catch (error) {
        console.error(error);
      }
    };

    async function listarParceiros() {
      await emitir.value.unidade.id;
      try {
        let response = await store.dispatch("ter/listarParceiros", {});
        listaParceiros.value = response.response.data.resultado.dados;
      } catch (error) {
        console.error(error);
      }
    }

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
        reset();
        listarArea();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    onMounted(() => {
      listarParceiros();
      getUnidade();
      listarArea();
    });

    watch(filtros, () => {
      listarTerceiros();
    });

    const criar = async () => {
      try {
        await store.dispatch("ter/criarTerceiro", {
          nome: terceiro.value.nome,
          matricula: terceiro.value.matricula,
          areaId: terceiro.value?.area?.areaId,
          parceiroId: terceiro.value.parceiro?.parceiroId,
          unidadeId: emitir.value.unidade.id,
        });

        $q.notify({
          message: "Funcionário cadastrado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        listarTerceiros();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.erro.detalhes) {
            $q.notify({
              message: `${index}: ${e.response.data.erro.detalhes[index]}`,
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const editar = async () => {
      try {
        await store.dispatch("ter/editarTerceiro", {
          terceiroId: dadoEditar.value.terceiroId,
          nome: dadoEditar.value.nome,
          matricula: dadoEditar.value.matricula,
          areaId: dadoEditar.value?.areaId?.areaId || dadoEditar.value?.areaId,
          parceiroId:
            dadoEditar.value.parceiroId?.parceiroId ||
            dadoEditar.value?.parceiroId,
          unidadeId: emitir.value.unidade.id,
        });

        $q.notify({
          message: "Funcionário editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        listarTerceiros();
      } catch (e) {
        if (e.request.status < 500) {
          for (let index in e.response.data.errors) {
            $q.notify({
              message: e.response.data.errors[index],
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const reset = async () => {
      terceiro.value = {};
      filtros.area = {
        terceiroId: "",
        parceiro: "",
        nome: "",
        matricula: "",
        area: "",
        email: "",
        celular: "",
      };
      dadoEditar.value = {};
      rightDrawerOpen.value = false;
    };

    const removerTerceiro = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("ter/removerTerceiro", {
            parceiroId: parceiroId.value,
            terceiroId: terceiroId.value,
            unidadeId: emitir.value.unidade.id,
          });
          $q.notify({
            message: "Terceiro removido com sucessso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listarTerceiros();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao remover terceiro",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (!rightDrawerOpen.value) {
          editarTerceiro.value = false;
          dadoEditar.value = {};
        }
      }
    );

    return {
      terceiro,
      loading,
      criar,
      myForm,
      listaTerceiros,
      listarArea,
      listaArea,
      listarParceiros,
      listaParceiros,
      listarTerceiros,
      columns,
      area,
      filtros,
      parceiro,
      emitir,
      getUnidade,
      removerTerceiro,
      editarTerceiro,
      dadoEditar,
      rightDrawerOpen,
      nomeTerceiroEditar,
      editar,
      confirmacao,
      parceiroId,
      terceiroId,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-tabela {
  font-size: 18px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.texto-titulo-modal {
  font-size: 16px;
  color: #21324a;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 70%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
    top: 107px;
  }
}
.input-modal {
  margin-bottom: 12px;
}
.texto-titulo-input {
  margin-top: 5px;
}
@media (max-width: 480px) {
  .drawer-modal {
    max-height: 70%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
    top: 107px;
  }
}
.input-modal {
  margin-bottom: 12px;
}
.texto-titulo-input {
  margin-top: 5px;
}
@media (max-width: 360px) {
  .drawer-modal {
    max-height: 70%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
    top: 107px;
  }
}
.input-modal {
  margin-bottom: 12px;
}
.texto-titulo-input {
  margin-top: 5px;
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
